<template>
  <div class="conclusion">
    <div class="part-one">
      <div class="Title">客户概览</div>
      <div class="content">
        <span class="content-left">
          <ul>
            <li>
              • 客户当前<span style="color:rgb(85, 85, 85);"
                    v-if="overviewList.childCountResult === '0'">客户当前暂无子女需要完成学业</span>
              <span style="color:rgb(85, 85, 85);"
                    v-else>有{{ overviewList.childCountResult }}个子女需要进行教育规划， 距离{{ overviewList.childCountResult > 1 ? "他们" : overviewList.childRelation === "4" ? "他" : "她" }}毕业最长还有{{ overviewList.maxYears }}年。 在未来的学习生涯中，将会产生学费{{ overviewList.eduAndLiveExpenseMap.sumEduExpense | addMoneyFilter }}元， 生活费{{ overviewList.eduAndLiveExpenseMap.sumLiveExpense | addMoneyFilter }}元。</span>
            </li>
            <li>• 客户当前已为子女准备了教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 计划未来每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元， 期望教育储备金每年能产生{{ overviewList.getReserveInfo.expectedRevenue | addMoneyFilter }}%的收益。</li>
            <li>
              • 客户的风险等级为<span style="color:rgb(85, 85, 85);"
                    v-if="overviewList.riskLevelInfo !== null">{{ overviewList.riskLevelInfo.riskLevel }}</span>。
            </li>
          </ul>
          <br />
          <div>
            <span v-for="(v, i) in childrenList"
                  :key="i"
                  class="children">
              {{ v.custName }}
              <br />
              <span v-if="v.currentClass !== 20">
                • 当前处于{{ v.currentClass | childrenFilters }}，距离毕业还有{{ v.graduationYear }}年
                <br />
                • 此间将产生学费{{ v.learnMoney | addMoneyFilter }}元，生活费{{ v.lifeMoney | addMoneyFilter }}元
              </span>
              <span v-else>• 当前子女{{ v.currentClass | childrenFilters }}。</span>
            </span>
          </div>
        </span>
        <v-chart :options="chargeOverviewData"
                 style="position: relative;bottom: 0;right: 0; width: 362px;
        height: 285px;border:1px solid rgba(235,238,245,1);"></v-chart>
      </div>
    </div>
    <div class="part-two">
      <div class="Title">测算分析</div>
      <div class="content">
        <ul>
          <li>
            <strong>1</strong>
            <p v-if="overviewList.getMeasureReserve.irr === '无法达成规划'">
              根据客户已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元，则
              <span class="red">{{ overviewList.getMeasureReserve.irr }}</span>
            </p>
            <p v-else-if="overviewList.getMeasureReserve.irr > 0">
              根据客户已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元， 则至少需要达到年化<span class="red">{{ overviewList.getMeasureReserve.irr.toFixed(2) }}%</span>的投资收益， 才能满足客户的规划需求。
            </p>
            <p v-else>根据客户已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元，<span class="red"> 则目前客户储备情况已能满足子女教育需求</span>。</p>
          </li>
          <li>
            <strong>2</strong>
            <p>
              根据客户每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ overviewList.getReserveInfo.expectedRevenue }}%， 则当前的子女教育储备金<span class="red">
                <span v-if="overviewList.getMeasureReserve.reserveGap === 0">存在资金缺口</span>
                <span v-else>资金富余</span>
                {{ overviewList.getMeasureReserve.reserveBreach | addMoneyFilter }}元 </span>。
            </p>
          </li>
          <li>
            <strong>3</strong>
            <p>
              根据客户已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ overviewList.getReserveInfo.expectedRevenue }}%，
              <span v-if="overviewList.getMeasureReserve.monthGap !== 2">
                则每月投入的子女教育储备金
                <span class="red">
                  <span v-if="overviewList.getMeasureReserve.monthGap === 0">存在资金缺口</span>
                  <span v-else>资金富余</span>
                  {{ overviewList.getMeasureReserve.monthBreach | addMoneyFilter }}元
                </span></span><span v-else
                    class="red"> {{ overviewList.getMeasureReserve.monthBreach }}</span>。
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="part-Three">
      <div class="Title">生涯仿真</div>
<span class="feasibility">当前可行性&nbsp;&nbsp;&nbsp;&nbsp;<span>{{meterData}}%</span></span>
      <div>
        <highCharts :id="id"
                    :option="option"
                    v-if="highChartsShow"></highCharts>
        <span v-else
              style="font-size: 16px;display: inline-block;width: 100%;text-align: center;"> 暂无数据</span>
      </div>
    </div>
    <div class="part-Four">
      <span>
        <div class="Title">产品方案</div>
        <div class="content">
          <div class="content-one">
            <div class="Title-two">方案描述</div>
            <div style="word-wrap: break-word;width:70%;" ref="programmeText"></div>
          </div>
          <div class="content-two">
            <div class="Title-two">产品列表</div>
            <span class="Title-three">理财</span>
            <br />
            <el-table :data="tableDataOne"
                      :header-cell-style="{ background: '#F5F7FA' }"
                      height="150px"
                      style="width: 100%;">
              <el-table-column prop="prdCode"
                               align="center"
                               label="产品代码"
                               width="150px">
                <template slot-scope="scope">
                  {{ scope.row.prdCode|prdNameFilterTwo }}
                </template>
              </el-table-column>
              <el-table-column label="产品名称"
                               align="center">
                <template slot-scope="scope">
                  <div @click="productDetails(scope.row)"
                       style="color:#3981F1;cursor:pointer;"> {{ scope.row.prdName|prdNameFilterTwo }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="investTerm"
                               align="center"
                               label="投资期限（天）"> </el-table-column>
              <el-table-column prop="performanceCriterion"
                               label="业绩比较基准"
                               align="center"> </el-table-column>
              <el-table-column prop="riskLevelRes"
                               align="center"
                               label="风险等级"> </el-table-column>
              <el-table-column label="购买金额（元）">
                <template slot-scope="scope">
                  {{ scope.row.purchasedMoney | addMoneyFilter }}
                </template>
              </el-table-column>
            </el-table>
            <br />
            <span class="Title-three">大额存单</span>
            <el-table :data="tableDataTwo"
                      :header-cell-style="{ background: '#F5F7FA' }"
                      height="150px"
                      style="width: 100%;">
              <el-table-column prop="prdCode"
                               align="center"
                               label="产品代码"
                               width="150px">
                <template slot-scope="scope">
                  {{ scope.row.prdCode|prdNameFilterTwo }}
                </template>
              </el-table-column>
              <el-table-column label="产品名称"
                               align="center">
                <template slot-scope="scope">
                  <div @click="productDetails(scope.row)"
                       style="color:#3981F1;cursor:pointer;"> {{ scope.row.prdName|prdNameFilterTwo }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="prdStatusRes"
                               align="center"
                               label="起存金额（元）">
                <template slot-scope="scope">
                  {{ scope.row.purchaseAmounts | addMoneyFilter }}
                </template>
              </el-table-column>
              <el-table-column prop="sellStatusRes"
                               align="center"
                               label="存单期限">
                <template slot-scope="scope">
                  {{ scope.row.termLimit  }}
                </template>
              </el-table-column>
              <el-table-column prop="topFlagRes"
                               align="center"
                               label="年利率">
                <template slot-scope="scope"> {{ scope.row.annualInsrate }}% </template>
              </el-table-column>
              <el-table-column label="购买金额（元）">
                <template slot-scope="scope">
                  {{ scope.row.purchasedMoney | addMoneyFilter }}
                </template>
              </el-table-column>
            </el-table>
            <br />
          </div>
        </div>
      </span>
    </div>
    <!--产品详情-->
    <financeDetailDialog ref="financeDetailDialog" />
    <depositDetailDialog ref="depositDetailDialog" />
  </div>
</template>
<script>
import financeDetailDialog from '../../../components/wpsp/productPlan/financeDetailDialog.vue';
import depositDetailDialog from '../../../components/wpsp/productPlan/depositDetailDialog.vue';

export default {
  name: 'conclusion',
  components: {
    financeDetailDialog,
    depositDetailDialog,
  },
  data() {
    return {
      // 客户概览数据集合
      overviewList: {
        childCountResult: '',
        childRelation: '',
        maxYears: '',
        eduAndLiveExpenseMap: {
          sumEduExpense: '',
          sumLiveExpense: '',
        },
        getReserveInfo: {
          currentMoney: '',
          monthMoney: '',
          expectedRevenue: '',
        },
        getMeasureReserve: {
          irr: '',
          reserveBreach: '',
          monthBreach: '',
        },
        riskLevelInfo: {
          riskLevel: '',
        },
      },

      // 教育费用概览环形图参数
      chargeOverviewData: JSON.parse(sessionStorage.getItem('childEduChargeOverviewData')),

      // 每个子女信息
      childrenList: [],

      // 生涯仿真图
      id: 'text',
      option: JSON.parse(sessionStorage.getItem('histogram')),
      highChartsShow: true,

      // 可行性分析仪表盘数据
      meterData: {},
      // 判断展示的内容
      meterStatus: '',

      // 产品方案描述文字
      programmeText: '',

      // 产品详情弹框数据集合
      dialogList: [],
      dialogLists: [],

      // 理财产品列表数据
      tableDataOne: [],
      // 储蓄产品列表数据
      tableDataTwo: [],

      // 产品详情弹框开关
      dialogFormVisible: false,
    };
  },
  watch: {},
  filters: {
    prdNameFilterTwo(value) {
      if (value.length > 8) {
        return `${value.slice(0, 8)}...`;
      }
      return value;
    },
    termLimitFilter(x) {
      if (x === '' || x === null || x === undefined) {
        return '-';
      }
      if (x === '1') {
        return '1个月';
      }
      if (x === '2') {
        return '3个月';
      }
      if (x === '3') {
        return '6个月';
      }
      if (x === '4') {
        return '9个月';
      }
      if (x === '5') {
        return '1年';
      }
      if (x === '6') {
        return '18个月';
      }
      if (x === '7') {
        return '2年';
      }
      if (x === '8') {
        return '3年';
      }
      if (x === '9') {
        return '5年';
      }
      return '-';
    },
    // 子女状态过滤器
    childrenFilters(v) {
      // eslint-disable-next-line no-unused-vars
      let i = '';
      switch (v) {
        case 0:
          i = '学龄前';
          break;
        case 1:
          i = '幼儿园小班';
          break;
        case 2:
          i = '幼儿园中班';
          break;
        case 3:
          i = '幼儿园大班';
          break;
        case 4:
          i = '小学一年级';
          break;
        case 5:
          i = '小学二年级';
          break;
        case 6:
          i = '小学三年级';
          break;
        case 7:
          i = '小学四年级';
          break;
        case 8:
          i = '小学五年级';
          break;
        case 9:
          i = '小学六年级';
          break;
        case 10:
          i = '初中一年级';
          break;
        case 11:
          i = '初中二年级';
          break;
        case 12:
          i = '初中三年级';
          break;
        case 13:
          i = '高中一年级';
          break;
        case 14:
          i = '高中二年级';
          break;
        case 15:
          i = '高中三年级';
          break;
        case 16:
          i = '大学一年级';
          break;
        case 17:
          i = '大学二年级';
          break;
        case 18:
          i = '大学三年级';
          break;
        case 19:
          i = '大学四年级';
          break;
        case 20:
          i = '已毕业';
          break;
        default:
          break;
      }
      return i;
    },
  },
  created() {
    // 获取客户概览的数据
    this.queryOverview();
    // 获取每个子女信息
    this.querychildren();
    // 获取可行性分析仪表盘数据;
    this.getEduAnalyzeFeasibilityFn();
    // 获取产品方案描述
    setTimeout(() => {
      this.queryProgramme();
    }, 1000);

    // 获取理财和大额存单的数据数据
    this.getSelectedPrdList();
  },
  methods: {
    // 获取客户概览的数据
    queryOverview() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.overview, parames).then((res) => {
        this.overviewList = res.data;
        sessionStorage.setItem('getMeasureReserve', JSON.stringify(res.data.getMeasureReserve));
      });
    },
    // 获取每个子女信息
    querychildren() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
          flagFrom: '1',
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.children, parames).then((res) => {
        if (res.errorCode === 'E00000') {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < res.data.childList.length; i++) {
            const arr = {
              custName: '', // 子女姓名
              currentClass: '', // 阶段
              graduationYear: '', // 离毕业年数
              lifeMoney: '', // 生活费
              learnMoney: '', // 学费
            };
            arr.custName = res.data.childList[i].custName;
            arr.currentClass = res.data.childList[i].currentClass;
            arr.graduationYear = res.data.childList[i].graduationYear;
            console.log(res.data.childList[i].childCostInfoList);
            // eslint-disable-next-line no-plusplus
            for (let y = 0; y < res.data.childList[i].childCostInfoList.length; y++) {
              if (res.data.childList[i].childCostInfoList[y].childrenType === '1') {
                arr.learnMoney = res.data.childList[i].childCostInfoList[y].moneyTotal;
              } else if (res.data.childList[i].childCostInfoList[y].childrenType === '2') {
                arr.lifeMoney = res.data.childList[i].childCostInfoList[y].moneyTotal;
              }
            }
            this.childrenList.push(arr);
          }
        }
      });
    },
    // 获取可行性分析仪表盘数据
    getEduAnalyzeFeasibilityFn() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
          status: 1,
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          riskLevel: JSON.parse(sessionStorage.getItem('custInfo')).riskLevel.replace('C', ''),
        },
      };
      this.$_post(this.$API.getEduAnalyzeFeasibility, parames).then((res) => {
        this.meterData = (res.data.info.ratio * 100).toFixed(2);
      });
    },
    // 获取产品方案描述
    queryProgramme() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
          planType: '1',
        },
      };
      this.$_post(this.$API.Programme, parames).then((res) => {
        if (res.errorCode === 'E00000') {
          this.$refs.programmeText.innerHTML = res.data.info.productPlanDescription;
        }
      });
    },
    // 获取理财和大额存单的数据数据
    getSelectedPrdList() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
          planType: '1',
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.getSelectedPrdList, parames).then((res) => {
        console.log(res);
        this.tableDataOne = [];
        this.tableDataTwo = [];
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < res.data.list.length; index++) {
          if (res.data.list[index].prdType === '1') {
            this.tableDataOne[this.tableDataOne.length] = res.data.list[index];
          } else if (res.data.list[index].prdType === '2') {
            this.tableDataTwo[this.tableDataTwo.length] = res.data.list[index];
          }
        }
      });
    },
    // 点击产品名称弹出产品详情
    productDetails(v) {
      // 理财产品
      if (v.prdType === '1') {
        this.$refs.financeDetailDialog.getFinanceDetail(v.prdId);
        // 大额存单
      } else if (v.prdType === '2') {
        this.$refs.depositDetailDialog.getDepositDetail(v.prdId);
      }
    },
  },
};
</script>
<style lang="scss">
html {
  min-width: 1024px;
}
.conclusion {
  .Title {
    padding: 16px 21px;
    font-size: 16px;
    color: rgba(48, 49, 51, 1);
    border-bottom: solid 1px #eeeeee;
  }
  .part-one {
    background: rgba(255, 255, 255, 1);
    .content {
      display: flex;
      justify-content: space-between;
      padding: 8px 20px 17px 20px;
      .content-left {
        display: inline-block;
        width: 60%;
        div {
          min-height: 181px;
          background: rgba(245, 247, 250, 1);
          .children {
            display: inline-block;
            width: 40%;
            padding: 9px 17px;
          }
        }
      }
    }
  }
  .part-two {
    background: rgba(255, 255, 255, 1);
    margin-top: 16px;
    .content {
      ul {
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        li {
          width: 28%;
          height: 105px;
          padding: 7px 14px 0 34px;
          background: rgba(245, 247, 250, 1);
          border-radius: 2px;
          position: relative;
          p {
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
            .red {
              color: #fa6b6b;
            }
          }
          strong {
            width: 30px;
            height: 30px;
            background: rgba(75, 160, 255, 1);
            border-radius: 2px;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
            position: absolute;
            top: 8px;
            left: -5px;
          }
        }
      }
    }
  }
  .part-Three {
    background: rgba(255, 255, 255, 1);
    margin-top: 16px;
    position: relative;
    .feasibility{
      position: absolute;
      z-index: 999;
      right: 25px;
      top: 65px;
        span{
font-size:20px;
color:#02BB6F;
font-style:italic;
        }
    }
  }
  .part-Four {
    display: flex;
    justify-content: space-between;
    display: inline-block;
      background: rgba(255, 255, 255, 1);
      margin-top: 16px;
      width: 100%;
      .content {
        .Title-two {
          padding: 12px 0px;
          font-size: 14px;
          color: rgba(48, 49, 51, 1);
        }
        .content-one {
          padding: 0px 20px;
          height: 25%;
          p {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
        }
        .content-two {
          height: 75%;
          padding: 0px 20px;
          .Title-three {
            padding-left: 10px;
            border-left: 5px solid #1e88ff;
            font-size: 14px;
            color: rgba(48, 49, 51, 1);
          }
        }
    }
  }
}
</style>
